import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Loader } from '@/components/atoms/Loader';
import { approveDiscordAuth } from '@/services/auth';

export const DiscordApprove = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Lien invalide.');
      return;
    }

    approveDiscordAuth(token)
      .then(() => {
        navigate('/home', { replace: true });
      })
      .catch(() => {
        setError('Ce lien est invalide ou a expiré. Relance une connexion depuis le site.');
      });
  }, []);

  if (error) {
    return (
      <main className="bg-page flex min-h-screen items-center justify-center p-5">
        <div className="w-full max-w-md text-center">
          <p className="mb-4 text-5xl">❌</p>
          <h2 className="text-content font-lexend mb-2 text-xl font-semibold">Lien invalide</h2>
          <p className="text-content/60 text-sm">{error}</p>
        </div>
      </main>
    );
  }

  return (
    <main className="bg-page flex min-h-screen items-center justify-center p-5">
      <div className="w-full max-w-md text-center">
        <Loader size={48} color="#f29602" />
        <p className="text-content/60 mt-4 text-sm">Connexion en cours...</p>
      </div>
    </main>
  );
};
